import { useState } from "react";
import { FileText } from "lucide-react";
import { TasksReportDialog } from "./TasksReportDialog";

export const TasksReportButton = ({ authFetch }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid="tasks-report-open" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 rounded-full bg-[#B57E17] text-white px-4 py-1.5 text-xs font-semibold shadow hover:opacity-90"><FileText size={13} /> Daily Mandatory Task Report From Guides</button>
      {open && <TasksReportDialog authFetch={authFetch} onClose={() => setOpen(false)} />}
    </>
  );
};
